export function GameData() {
    this.postagem = {
        nome_op: '',
        username_op: '',
        imagem_op: '',
        avatar_op: '',
        texto_op: '',
    };

    this.npc = {
        nome: '',
        avatar: ''
    };

    this.jogador = {
        nome: '',
        avatar: ''
    };

    this.comentario_inicial = '';

    this.respostas = [
        new Resposta()
    ];
}

export function Resposta() {
    this.texto_jogador = '';
    this.texto_npc = '';
    this.mensagem_final = '';
    this.respostas = [];
}
